import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ContactFormDialog } from '@/components/landing/ContactFormDialog';

export function Footer() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
    <footer className="mt-24 border-t border-border/70 bg-cream-warm/60">
      <div className="container grid gap-10 py-14 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <a href="#top" className="flex items-center">
            <img src="/brand/cpn_mark.svg" alt="CPN" className="h-9 w-9" />
          </a>
          <p className="mt-4 max-w-sm text-sm text-muted">
            A safe and welcoming community for young and young-at-heart Cambodian
            professionals — worldwide, since 2013.
          </p>
        </div>

        <FooterColumn
          title="Network"
          links={[
            { href: '#story', label: 'Our story' },
            { href: '#pillars', label: 'What we do' },
            { href: '#map', label: 'Members' },
            { href: '#events', label: 'Events' },
          ]}
        />
        <FooterColumn
          title="Connect"
          links={[
            {
              href: 'https://www.facebook.com/groups/1397814990465516/',
              label: 'Facebook group',
              external: true,
            },
            { href: '#join', label: 'Newsletter' },
            { label: 'Contact us', onClick: () => setContactOpen(true) },
          ]}
        />
        <div>
          <h4 className="mb-3 font-display text-sm text-navy">Resources</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#faq" className="text-muted transition-colors hover:text-navy">
                FAQ
              </a>
            </li>
            <li>
              <Link to="/privacy" className="text-muted transition-colors hover:text-navy">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="text-muted transition-colors hover:text-navy">
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border/60">
        <div className="container flex flex-col gap-2 py-5 text-xs text-muted sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 The Cambodian Professionals Network · Est. 2013</span>
          <span>
            <span className="khmer">ខ្មែរ</span> · Khmer · សាមគ្គីភាព · Solidarity
          </span>
        </div>
      </div>
    </footer>

    <ContactFormDialog open={contactOpen} onOpenChange={setContactOpen} />
    </>
  );
}

type FooterLink =
  | { href: string; label: string; external?: boolean; onClick?: never }
  | { href?: never; label: string; external?: never; onClick: () => void };

function FooterColumn({ title, links }: { title: string; links: FooterLink[] }) {
  return (
    <div>
      <h4 className="mb-3 font-display text-sm text-navy">{title}</h4>
      <ul className="space-y-2 text-sm">
        {links.map((link) => (
          <li key={link.label}>
            {link.onClick ? (
              <button
                type="button"
                onClick={link.onClick}
                className="text-muted transition-colors hover:text-navy"
              >
                {link.label}
              </button>
            ) : (
              <a
                href={link.href}
                target={link.external ? '_blank' : undefined}
                rel={link.external ? 'noopener noreferrer' : undefined}
                className="text-muted transition-colors hover:text-navy"
              >
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
